export default __webpack_public_path__ + "static/media/frame-4.88fb3914.jpg";